module.exports = __webpack_public_path__ + "img/img-5.416a5341.webp";